module.exports = __webpack_public_path__ + "img/zgdsdialog.0ecc6000.jpg";